import { motion } from 'framer-motion';
import { useState } from 'react';
import { 
  HiOutlineMail, 
  HiOutlineLocationMarker, 
  HiOutlinePhone,
  HiOutlineCreditCard
} from 'react-icons/hi';
import { FaFax, FaBuilding, FaUser, FaIdCard } from 'react-icons/fa';
import './Footer.scss';
import '../login/Terms.scss';
import imgLogo from '../../images/icons/logo-gray.png';
import TermsOfService from '../login/TermsOfService';
import PrivacyPolicy from '../login/PrivacyPolicy';

const Footer = () => {
  const currentYear = '2026';
  const [showTermsModal, setShowTermsModal] = useState(false);
  const [showPrivacyModal, setShowPrivacyModal] = useState(false);

  const companyInfo = [
    { icon: '', label: '회사명', value: '대화소프트 (Daehwa Software)' },
    { icon: '', label: '서비스', value: 'MathTailer (매쓰테일러)' },
    { icon: '', label: '대표번호', value: '1800-0981' },
    { icon: '', label: '사업자등록번호', value: '855-47-01044' },
    { icon: '', label: '통신판매업 신고번호', value: '2026-인천부평-1360' },
  ];

  const contactInfo = [
    { icon: '', label: '대표 · 개인정보책임자', value: '홍대화' },
    { icon: '', label: '공식 이메일', value: 'admin@mathtailer.com' },
    { icon: '', label: '고객지원', value: 'mathtailer@naver.com' },
    { icon: '', label: '주소', value: '인천광역시 부평대로 68, 5층 578호(부평동)' },
    { icon: '', label: '입금계좌', value: '신한은행 110-626-397314 (예금주: 대화소프트)' },
  ];

  return (
    <footer className="footer">
      <div className="inner">
        <motion.div
          className="top"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <div className="brand">
            <img src={imgLogo} alt="logo" className="logo-img" />
            <h3 className="logo">매쓰테일러</h3>
          </div>

          <div className="info">
            <ul className="list">
              {companyInfo.map((item, index) => (
                <li key={index} className="item">
                  <span className="label">{item.label}:</span>
                  <span className="value">{item.value}</span>
                </li>
              ))}
            </ul>
            <ul className="list">
              {contactInfo.map((item, index) => (
                <li key={index} className="item">
                  <span className="label">{item.label}:</span>
                  <span className="value">{item.value}</span>
                </li>
              ))}
            </ul>
          </div>
        </motion.div>

        <div className="bottom">
          <div className="links">
            <button onClick={() => setShowTermsModal(true)} className="link">이용약관</button>
            <span className="separator">|</span>
            <button onClick={() => setShowPrivacyModal(true)} className="link privacy">개인정보 처리방침</button>
          </div>
          <p className="copyright">© {currentYear} 매쓰테일러. All rights reserved.</p>
        </div>
      </div>

      {/* 이용약관 모달 */}
      {showTermsModal && (
        <div className='terms-modal' onClick={() => setShowTermsModal(false)}>
          <div className='modal-content' onClick={(e) => e.stopPropagation()}>
            <div className='modal-header'>
              <h3>이용약관</h3>
              <button className='close-btn' onClick={() => setShowTermsModal(false)}>×</button>
            </div>
            <div className='modal-body'>
              <TermsOfService />
            </div>
            <div className='modal-footer'>
              <button onClick={() => setShowTermsModal(false)}>닫기</button>
            </div>
          </div>
        </div>
      )}

      {/* 개인정보 처리방침 모달 */}
      {showPrivacyModal && (
        <div className='terms-modal' onClick={() => setShowPrivacyModal(false)}>
          <div className='modal-content' onClick={(e) => e.stopPropagation()}>
            <div className='modal-header'>
              <h3>개인정보 처리방침</h3>
              <button className='close-btn' onClick={() => setShowPrivacyModal(false)}>×</button>
            </div>
            <div className='modal-body'>
              <PrivacyPolicy />
            </div>
            <div className='modal-footer'>
              <button onClick={() => setShowPrivacyModal(false)}>닫기</button>
            </div>
          </div>
        </div>
      )}
    </footer>
  );
};

export default Footer;
